import styled from "styled-components";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import QualityLogo from "../../assets/images/qualicoat.png";

/* ===================== STYLES ===================== */

const FooterWrapper = styled.footer`
  background: linear-gradient(180deg, #0f0f0f 0%, #1a1a1a 100%);
  color: #ffffff;
  padding: 64px 24px 32px;
`;

const FooterGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 48px;
`;

const Section = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    position: relative;
    color: #ff5e14;
  }

  h3::after {
    content: "";
    display: block;
    width: 32px;
    height: 2px;
    background-color: #ff5e14;
    margin-top: 8px;
  }
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 10px;
  }

  a {
    color: #dcdcdc;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;

    &:hover {
      color: #ff5e14;
    }
  }
`;

const ContactText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 8px;
  color: #dcdcdc;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 12px;

  a {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #222;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 18px;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ff5e14;
      transform: translateY(-3px);
    }
  }
`;

const CertificationBox = styled.div`
  width: 160px;

  img {
    width: 100%;
    filter: brightness(0) invert(1);
  }
`;

const FooterBottom = styled.div`
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid #2a2a2a;
  text-align: center;
  font-size: 13px;
  color: #aaaaaa;

  a {
    color: #aaaaaa;
    text-decoration: none;
    margin-left: 6px;

    &:hover {
      color: #ff5e14;
    }
  }
`;

const Developer = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: #777;
`;

/* ===================== COMPONENT ===================== */

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterGrid>
        <Section>
          <h3>A Empresa</h3>
          <NavList>
            <li>
              <Link to="/sobre-nos">Sobre Nós</Link>
            </li>
            <li>
              <Link to="/produtos">Produtos</Link>
            </li>
            <li>
              <Link to="/contatos">Contato</Link>
            </li>
          </NavList>
        </Section>

        <Section>
          <h3>Contato</h3>
          <ContactText>Rua Arcângelo João Grapiglia, 61</ContactText>
          <ContactText>Área Industrial – Medianeira, PR</ContactText>
          <ContactText>(45) 9828-0932</ContactText>
        </Section>

        <Section>
          <h3>Redes Sociais</h3>
          <SocialRow>
            <a
              href="https://www.facebook.com/profile.php?id=61568965868313"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.linkedin.com/company/105695510/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/omegaluminios"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
          </SocialRow>
        </Section>

        <Section>
          <h3>Certificações</h3>
          <CertificationBox>
            <img src={QualityLogo} alt="Certificação Qualicoat" />
          </CertificationBox>
        </Section>
      </FooterGrid>

      <FooterBottom>
        <div>© 2025 Omega Alumínios — Todos os direitos reservados</div>
        <div>
          <Link to="/termos-privacidade">Privacidade e Termos de Uso</Link>
        </div>
        <Developer>Desenvolvido por Farouk Ait Nasser</Developer>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer;
